import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

import Dialog from 'src/components/dialog/Dialog';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void | Promise<void>;
    isDeleting: boolean;
};

export default function DeleteTourConfirmModal({ open, onClose, onConfirm, isDeleting }: Props) {
    return (
        <Dialog
            open={open}
            onClose={() => {
                if (!isDeleting) {
                    onClose();
                }
            }}
            maxWidth="xs"
            fullWidth
            aria-labelledby="delete-tour-dialog-title"
        >
            <DialogTitle id="delete-tour-dialog-title">Delete tour?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to delete this tour? This cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onClose} disabled={isDeleting}>
                    Cancel
                </Button>
                <LoadingButton
                    variant="contained"
                    color="error"
                    onClick={() => void onConfirm()}
                    loading={isDeleting}
                >
                    Delete
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
